import {
    IDataTypeResponse,
    INodeOutputSensorDataConfigSlot,
} from '@kcftech/prometheustypescriptapiclient';
import { Dropdown } from 'components/dropdown/Dropdown';
import { useInfiniteDataTypesDataSource } from 'custom_hooks/data_hooks/data_source/dataTypeDataSource';
import { dropdownTriggerStyles } from 'pages/Settings/ThirdPartySensorModels/styled';
import { useThemeValues } from 'styles/theme';

export type DataTypeDropdownProps = Readonly<{
    slot?: INodeOutputSensorDataConfigSlot;
    value: IDataTypeResponse | undefined;
    onChange: (newValue: IDataTypeResponse | undefined) => void;
}>;

export function DataTypeDropdown({ slot, value, onChange }: DataTypeDropdownProps) {
    const { shadeBackgroundColor, borderColor } = useThemeValues();

    const {
        results,
        hasNext,
        loadNext,
        isLoading,
        filter,
        setFilter,
    } = useInfiniteDataTypesDataSource({
        name: 'data-type-dropdown',
        defaultFilter: { slot },
    });

    return (
        <Dropdown<IDataTypeResponse>
            trigger={{
                style: {
                    ...dropdownTriggerStyles,
                    backgroundColor: shadeBackgroundColor,
                    border: `2px solid ${borderColor}`,
                },
            }}
            dataKey={(item) => item.Id}
            data={{
                items: results,
                hasMore: hasNext ?? false,
                onLoadMore: loadNext,
                isLoading,
            }}
            filterable={{
                placeholder: 'Search data types',
                filterText: filter.nameSearch ?? '',
                onChange: (nameSearch) =>
                    setFilter((existing) => ({ ...existing, nameSearch })),
            }}
            value={value}
            renderItem={({ item }) => item.Name}
            renderLabel={() => value?.Name ?? 'Select a data type'}
            onChange={onChange}
        />
    );
}
